module.exports = __webpack_public_path__ + "img/travel_tiger_market_2.d4502b13.webp";